import styled from "styled-components";

export const Container = styled.div`
  max-width: 434px;
  flex: 1;
  padding: 18px 27px;
  border-right: 1px solid #0000001a;
  transition: max-width 0.3s;
  .checkbox {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    height: 30px;
    padding: 0 16px;
    display: inline-flex;
    .MuiTypography-root {
      font-size: 14px;
    }
  }
  @media (max-width: 1400px) {
    max-width: 300px;
  }
  @media (max-width: 1174px) {
    max-width: 100%;
    border: none;
    width: 100%;
    display: flex;
    gap: 35px;
    > div {
      flex: 1;
    }
  }
  @media (max-width: 1400px) {
    flex-direction: column;
    gap: 0;
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 5px;
  h3 {
    text-transform: uppercase;
    font-size: 16px;
    display: inline-flex;
    gap:5px;
    align-items: center; 
  }
`;

export const AddEmailInput = styled.div`
  padding: 20px 0 26px;
  input {
    height: 40px;
    background: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    padding: 9px 15px;
    width: 100%;
  }
`;

export const PlayerAssistance = styled.div`
  margin-top: 15px;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 0;
    font-size: 14px;
    > span {
      display: inline-flex;
      gap: 9px;
      align-items: center;
    }
    /* :first-child {
      font-weight: 700;
      border-bottom: 1px solid #0000001a;
      padding: 31px 0 10px 0;
      margin-bottom: 5px;
      font-size: 16px;
    } */
  }
  button {
    font-weight: 500;
    font-size: 12px;
    line-height: 150.5%;
    border: 1px solid #666666;
    border-radius: 6px;
    display: flex;
    align-items: center;
    background: var(--input-background);
    gap: 6px;
    height: 28px;
    font-family: "Roboto";
    min-width: 110px;
    &.assistance-btn {
      font-size: 16px;
      line-height: 19px;
      /* width: 160px; */
      padding: 0 15px;
      justify-content: center;
    }
    &.text-center {
      justify-content: center;
    }
    &.active {
      color: var(--theme-text);
      border: none;
      background: var(--selected-btn-bg);
      svg {
        path {
          fill: var(--theme-text);
        }
      }
    }
  }
  > div {
    display: grid;
    grid-template-columns: 122px 122px;
    gap: 13px 10px;
    padding: 24px 0;
    margin-top: 19px;
    border-top: 1px solid #0000001a;
  }
  @media (max-width: 850px) {
    button {
      height: 36px;
      &.assistance-btn {
        width: 100%;
      }
    }
    > div {
      grid-template-columns: 1fr 1fr;
    }
  }
`;

export const ActionBtn = styled.div`
  display: flex;
  gap: 9px;
  align-items: center;
  justify-content: flex-end;
  padding-top: 23px;
  border-top: 1px solid #0000001a;
  button {
    min-width: 78px;
  }
`;
